import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function StravaCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const code = searchParams.get("code");
    const state = searchParams.get("state");
    const scope = searchParams.get("scope") || "";
    if (!code || !state) {
      navigate("/challenges?strava=denied", { replace: true });
      return;
    }
    axios
      .post(`${API}/strava/exchange`, { code, state, scope })
      .then(() => navigate("/challenges?strava=connected", { replace: true }))
      .catch(() => navigate("/challenges?strava=denied", { replace: true }));
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen bg-[#FBF9F5] flex flex-col items-center justify-center gap-5" data-testid="strava-callback">
      <Loader2 className="w-8 h-8 animate-spin text-[#FF4E00]" />
      <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#6B7280]">Connecting your Strava...</p>
    </div>
  );
}
